// SPDX-License-Identifier: AGPL-3.0-only

/**
 * Produces a valid, normalized initial slug from a tenant display name.
 * The result is only a suggestion; callers must leave manual edits intact.
 */
export function suggestedTenantSlug(displayName: string): string {
  return displayName
    .trim()
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}
